import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=227e38bc&scoped=true&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"
import style0 from "./cancel.vue?vue&type=style&index=0&id=227e38bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e38bc",
  null
  
)

export default component.exports